module.exports = __webpack_public_path__ + "img/setting_btn.60de96cd.png";